module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/129-ossetia-d5a29c10c0cfe58746a72fb531b1e2b2.svg";